import { DevicesListController } from './devices.list';

export function DevicesController() {

  const devicesList = new DevicesListController();

  return {};
}